import MeetingMW from "@/middlewares/Meeting";

import MeetingORM from "@/store/orm-axios/models/Meeting";
import BuildingORM from "@/store/orm-axios/models/Building";
import MajorityORM from "@/store/orm-axios/models/Majority";
import MandateORM from "@/store/orm-axios/models/Mandate";
import ContactORM from "@/store/orm-axios/models/Contact";
import VotingCategoryORM from "@/store/orm-axios/models/VotingCategory";
import BuildingMajoritiesORM from "@/store/orm-axios/models/BuildingMajorities";
import { defaultSansVoteMajorityId } from "@/constants/default.js";

import { mapActions } from "vuex";

export default {
  methods: {
    ...mapActions({
      sendErrorToAdmin: "adminNotification/sendErrorToAdmin",
    }),
    setMeetingDetailsStoreVariables(hasFreezedMeetingDetails) {
      try {
        if (hasFreezedMeetingDetails) {
          this.$store.commit(
            "meetingDetails/setFreezedMeetingDetails",
            this.meeting.freezed_meeting_details
          );
        } else {
          this.$store.commit("meetingDetails/setMeetingDetailsMeetingId", this.meeting.id);

          this.setBuildingData(this.meeting.building_id);
          this.setMajoritiesData(this.meeting.building_id);

          this.setContactsData(this.meeting.building_id);
          this.setBuildingOwnersData(this.meeting.id, this.meeting.building_id);
        }
      } catch (err) {
        console.error(err);
        this.$swal(
          this.alertError(
            "Erreur",
            "Une erreur s'est produite lors de la configuration des détails de la réunion",
            5000
          )
        );
        // NOTE: In case of error, set freezed_meeting_details empty
        this.$store.commit("meetingDetails/setFreezedMeetingDetails", []);

        throw new Error();
      }
    },
    setBuildingData(buildingId) {
      var buildingAllData = BuildingORM.find(buildingId);
      var buildingNeededData = {
        id: buildingAllData.id,
        name: buildingAllData.name,
        slug: buildingAllData.slug,
        address: buildingAllData.address,
        legal: buildingAllData.legal,
      };
      this.$store.commit("meetingDetails/setMeetingDetailsBuildingData", buildingNeededData);
    },
    setMajoritiesData(buildingId) {
      const majoritiesAllData = MajorityORM.query().get();
      const majorities = this.filterMajorities(majoritiesAllData, buildingId);

      var majoritiesNeededData = [];
      majorities.forEach(m => {
        majoritiesNeededData.push({
          id: m.id,
          name: m.name,
          slug: m.slug,
          majority_conditions: m.majority_conditions,
        });
      });
      if (majorities.length > 0 && majoritiesNeededData.length == 0) {
        throw new Error("Majorities data for freezed_meeting_details cannot be empty");
      }

      // NOTE: Make sure that 'Sans Vote' majority is added to freezed_meeting_details
      const foundSansVoteMajority = majoritiesNeededData.find(
        item => item.id == defaultSansVoteMajorityId
      );
      if (majorities.length > 0 && !foundSansVoteMajority)
        throw new Error(
          "Majorities Sans Vote was not found to be added in freezed_meeting_details"
        );

      this.$store.commit("meetingDetails/setMeetingDetailsMajoritiesData", majoritiesNeededData);
    },
    setContactsData(buildingId) {
      var contactsData = this.$store.getters["meetingDetails/getMeetingDetailsContactsData"] || [];
      var contacts = ContactORM.query().where("building_id", buildingId).get();
      this.$_.each(contacts, c => {
        var contactDetails = this.getContactDetails(c);
        let contactAlreadyAdded = contactsData.find(item => item.id == contactDetails.id);
        if (!contactAlreadyAdded) {
          contactsData.push(contactDetails);
        }
      });

      this.$store.commit("meetingDetails/setMeetingDetailsContactsData", contactsData);
    },
    getContactDetails(contact) {
      var name = (
        (contact.lastname ? contact.lastname + " " : "") +
        (contact.firstname ? contact.firstname : "")
      ).toUpperCase();

      return {
        id: contact.id,
        identifier: "contact-" + contact.id,
        type: "contact",

        entity_type: contact.entity_type,

        gender: contact.gender,
        firstname: contact.firstname,
        lastname: contact.lastname,
        name,

        search: name,

        address: contact.address,
        complement: contact.complement,
        complement2: contact.complement2,
        zipcode: contact.zipcode,
        city: contact.city,
        country: contact.country,

        /**
         * !!!: ..
         * totalMandateVotes is set to 1 for BOs and 0 for Contacts
         * votingIncludesMandate used to influence totalMandateVotes too in the beginning but for now it remained only for tantiemes represented..
         */
        totalMandateVotes: 0,
        totalMandateTantiemesChargeGenerale: 0,
      };
    },
    setBuildingOwnersData(meetingId, buildingId) {
      var votingCategories = this.getVotingCategories(buildingId);
      this.$store.commit("meetingDetails/setMeetingDetailsVotingCategoriesData", votingCategories);

      var votingRightsByVotingCategory = this.getVotingRightsByVotingCategorySpecialObject(
        votingCategories
      );
      var { buildingOwnersData, buildingOwnersWithReducedTantiemes } = this.getBuildingOwnersData(
        meetingId,
        votingRightsByVotingCategory
      );
      this.$store.commit("meetingDetails/setMeetingDetailsBuildingOwnersData", buildingOwnersData);
      this.$store.commit(
        "meetingDetails/setMeetingDetailsBuildingOwnersWithReducedTantiemes",
        buildingOwnersWithReducedTantiemes
      );
    },
    getVotingCategories(buildingId) {
      var votingCategoriesNeededData = [];
      var votingCategoriesAllData = VotingCategoryORM.query()
        .where("building_id", buildingId)
        .get();
      votingCategoriesAllData.forEach(vc => {
        votingCategoriesNeededData.push({
          id: vc.id,
          name: vc.name,
          slug: vc.slug,
          is_charge_generale: vc.is_charge_generale,
        });
      });
      return votingCategoriesNeededData;
    },
    getVotingRightsByVotingCategorySpecialObject(votingCategories) {
      var votingRightsByVotingCategory = {};
      votingCategories.forEach(vc => {
        votingRightsByVotingCategory[vc.id] = { ...vc, tantiemes: 0, byBuildingLot: {} };
      });
      return votingRightsByVotingCategory;
    },
    getBuildingOwnersData(meetingId, votingRightsByVotingCategory) {
      var buildingOwnersData = [];
      var buildingOwnersWithReducedTantiemes = [];
      var mandates = MandateORM.query()
        .where("meeting_id", meetingId)
        .with("building_owner.building_owner_building_lots.building_lot")
        .with(
          "building_owner.building_owner_building_lots.building_owner_voting_rights.voting_category"
        )
        .get();
      mandates.forEach(m => {
        if (!m.building_owner) return;
        var boDetails = this.getBuildingOwnerDetails(
          m.building_owner,
          m.id,
          votingRightsByVotingCategory
        );
        buildingOwnersData.push(boDetails);

        if (boDetails.reducedMandateTantiemesChargeGenerale) {
          buildingOwnersWithReducedTantiemes.push(boDetails);
        }
      });

      return { buildingOwnersData, buildingOwnersWithReducedTantiemes };
    },
    getBuildingOwnerDetails(xBO, xMandateId, xVotingRightsByVotingCategory) {
      var votingRightsByVotingCategory = JSON.parse(JSON.stringify(xVotingRightsByVotingCategory));

      var name = this.getPersonName({}, xBO);

      var buildingLots = [];
      let totalMandateTantiemesChargeGenerale = 0;
      var reducedMandateTantiemesChargeGenerale = undefined;

      this.$_.each(xBO.building_owner_building_lots, bobl => {
        buildingLots.push({
          id: bobl.building_lot.id,
          name: bobl.building_lot.name,
          slug: bobl.building_lot.slug,
        });

        for (const votingRight of bobl.building_owner_voting_rights) {
          if (!votingRight.voting_category) {
            continue;
          }

          votingRightsByVotingCategory[votingRight.voting_category.id].name =
            votingRight.voting_category.name;
          votingRightsByVotingCategory[votingRight.voting_category.id].is_charge_generale =
            votingRight.voting_category.is_charge_generale;
          votingRightsByVotingCategory[votingRight.voting_category.id].tantiemes +=
            votingRight.parts;

          votingRightsByVotingCategory[votingRight.voting_category.id].byBuildingLot[
            bobl.building_lot.id
          ] = {
            id: bobl.building_lot.id,
            name: bobl.building_lot.name,
            slug: bobl.building_lot.slug,
            tantiemes: votingRight.parts,
          };

          if (votingRight.voting_category.is_charge_generale) {
            totalMandateTantiemesChargeGenerale += votingRight.parts;

            if (this.votingLimitRules.article22IsActive) {
              if (xBO.id == this.votingLimitRules.buildingOwnerIdArticle22) {
                votingRightsByVotingCategory[
                  votingRight.voting_category.id
                ].reducedMandateTantiemesChargeGenerale = this.votingLimitRules.reducedMandateTantiemesArticle22;
              }
            } else if (this.votingLimitRules.plafonMajorityIsActive) {
              if (
                totalMandateTantiemesChargeGenerale > this.votingLimitRules.plafonMajorityTantiemes
              ) {
                votingRightsByVotingCategory[
                  votingRight.voting_category.id
                ].reducedMandateTantiemesChargeGenerale = this.votingLimitRules.plafonMajorityTantiemes;
              }
            }
          }
        }
      });

      if (this.votingLimitRules.article22IsActive) {
        if (xBO.id == this.votingLimitRules.buildingOwnerIdArticle22) {
          reducedMandateTantiemesChargeGenerale = this.votingLimitRules
            .reducedMandateTantiemesArticle22;
        }
      } else if (this.votingLimitRules.plafonMajorityIsActive) {
        if (totalMandateTantiemesChargeGenerale > this.votingLimitRules.plafonMajorityTantiemes) {
          reducedMandateTantiemesChargeGenerale = this.votingLimitRules.plafonMajorityTantiemes;
        }
      }

      var toReturn = {
        id: xBO.id,
        mandate_id: xMandateId,
        identifier: "owner-" + xBO.id,
        type: "owner",

        entity_type: xBO.entity_type,
        email: xBO.email,

        gender: xBO.gender,
        firstname: xBO.firstname,
        lastname: xBO.lastname,
        name,

        building_lots: buildingLots,

        search: name + " " + buildingLots.map(x => x.name).join(", "),

        address: xBO.address,
        complement: xBO.complement,
        complement2: xBO.complement2,
        zipcode: xBO.zipcode,
        city: xBO.city,
        country: xBO.country,

        /**
         * !!!: ..
         * total mandateVotes is set to 1 for BOs and 0 for Contacts
         * votingIncludesMandate used to influence totalMandateVotes too in the beginning but for now it remained only for tantiemes represented..
         * might need extra computations in other place in the app ( e.g. if (item.type == "owner") totalMandateVotes--; )
         */
        totalMandateVotes: 1,
        totalMandateTantiemesChargeGenerale,
        votingRightsByVotingCategory,
        settings: xBO.settings,
        building_asl_id: xBO.building_asl_id,
      };
      if (reducedMandateTantiemesChargeGenerale) {
        toReturn.reducedMandateTantiemesChargeGenerale = reducedMandateTantiemesChargeGenerale;
      }

      // NOTE: DEV-4661
      if (!xBO.country) {
        this.sendErrorToAdmin({
          message: `When setting buildingOwner details for meeting->freezedMeetingDetails this buildingOwner has country field missing.`,
          jsonData: JSON.stringify(toReturn),
        });
      }

      return toReturn;
    },

    // !!!: ..
    async setFreezedMeetingDetailsInMeeting(saveInDb = false) {
      try {
        var self = this;
        MeetingORM.update({
          where: self.$route.params.id,
          data(item) {
            item.freezed_meeting_details = self.meetingDetails;
          },
        });

        if (saveInDb) await this.saveMeetingInDb(this.$route.params.id);
      } catch (err) {
        console.error(err);
        this.$swal(this.alertError());
      }
    },

    // INFO: video arrived/left functionality ..
    async checkIfVideoParticipantsArrivedOrLeft(meeting) {
      try {
        if (this.$store.state.isLoadingUpdateMultipleMandatesLastSeen) return;
        this.$store.state.isLoadingUpdateMultipleMandatesLastSeen = true;

        if (meeting.status == this.meetingStatuses.started) {
          var currentVideoMandates = this.getCurrentVideoMandates(meeting.id);

          if (currentVideoMandates.length > 0) {
            var arrivedVideoMandates = this.getArrivedVideoMandates(currentVideoMandates);
            var leftVideoMandates = this.getLeftVideoMandates(currentVideoMandates);

            var mandatesToUpdate = [];
            var arrivedMandatesToUpdate = [];
            var leftMandatesToUpdate = [];

            if (arrivedVideoMandates.length > 0) {
              arrivedMandatesToUpdate = this.setArrivedVideoMandatesPlusMinutes(
                arrivedVideoMandates
              );
              this.showVideoMandatesThatArrived(arrivedVideoMandates);
            }
            if (leftVideoMandates.length > 0) {
              leftMandatesToUpdate = this.setLeftVideoMandatesPlusMinutes(leftVideoMandates);
              this.showVideoMandatesThatLeft(leftVideoMandates);
            }

            mandatesToUpdate = arrivedMandatesToUpdate.concat(leftMandatesToUpdate);
            if (mandatesToUpdate.length > 0) {
              await this.updateMultipleMandatesLastSeen(mandatesToUpdate);
            }

            if (arrivedVideoMandates.length > 0 || leftVideoMandates.length > 0) {
              await this.saveModifiedMeetingMinutesInDb(meeting.id);
            }
          }
        }

        this.$store.state.isLoadingUpdateMultipleMandatesLastSeen = false;
      } catch (err) {
        this.$store.state.isLoadingUpdateMultipleMandatesLastSeen = false;
        console.error(err);
      }
    },
    // current video mandates
    getCurrentVideoMandates(meetingId) {
      return MandateORM.query()
        .where(m => {
          return (
            (m.presence_status == this.mandatePresenceStatuses.video ||
              m.presence_status == this.mandatePresenceStatuses.pouvoir_by_video) &&
            m.showed_up == 1 &&
            // ???: !!m.last_seen &&
            !m.dummy_video_presence_status
          );
        })
        .where("meeting_id", meetingId)
        .orderBy("presence_status") // get present by video first
        .get();
    },
    // get arrived / left video mandates
    getArrivedVideoMandates(currentVideoMandates) {
      return this.$_.filter(currentVideoMandates, mandate => {
        return mandate.just_arrived_by_video === 1;
      });
    },
    getLeftVideoMandates(currentVideoMandates) {
      return this.$_.filter(currentVideoMandates, mandate => {
        const mandateLastSeen = MandateORM.getters("getMandateLastSeen")(mandate.id);

        // ???: ..
        if (!mandateLastSeen) return true;

        const lastSeen = this.$moment(mandateLastSeen.last_seen);
        const offset = this.$moment().subtract(
          process.env.VUE_APP_CHECK_LAST_SEEN_INTERVAL * 12,
          "milliseconds"
        );

        return (
          this.$moment(lastSeen).isBefore(this.$moment(offset)) &&
          mandate.just_arrived_by_video !== 1
        );
      });
    },
    // set arrived / left video mandates
    setArrivedVideoMandatesPlusMinutes(arrivedVideoMandates) {
      var mandatesToUpdate = [];
      var contactsArrivedIds = [];
      arrivedVideoMandates.forEach(mandate => {
        if (mandate.presence_status == this.mandatePresenceStatuses.video) {
          this.setParticipantArrivedEvent(mandate.id, false);
        } else if (mandate.presence_status == this.mandatePresenceStatuses.pouvoir_by_video) {
          // set contact arrived through video if it's the case
          if (
            mandate.representant_contact_id &&
            !contactsArrivedIds.includes(mandate.representant_contact_id)
          ) {
            this.setContactArrivedEvent(mandate.representant_contact_id, false);
            contactsArrivedIds.push(mandate.representant_contact_id);
          }

          this.setMandateAddedEvent(mandate.id, false);
        }

        mandatesToUpdate.push(mandate);
      });
      return mandatesToUpdate;
    },
    setLeftVideoMandatesPlusMinutes(leftVideoMandates) {
      var mandatesToUpdate = [];
      var contactsLeftIds = [];
      leftVideoMandates.forEach(mandate => {
        if (mandate.presence_status == this.mandatePresenceStatuses.video) {
          this.setParticipantLeftEvent(mandate.id, false);
        } else if (mandate.presence_status == this.mandatePresenceStatuses.pouvoir_by_video) {
          // set contact left through video if it's the case
          if (
            mandate.representant_contact_id &&
            !contactsLeftIds.includes(mandate.representant_contact_id)
          ) {
            this.setContactLeftEvent(mandate.representant_contact_id, false);
            contactsLeftIds.push(mandate.representant_contact_id);
          }

          this.setMandateLeftEvent(mandate.id, false);
        }

        MandateORM.update({
          where: mandate.id,
          data: {
            presence_status: 0,
            dummy_video_presence_status: 0,
          },
        });
        MandateORM.store().commit("entities/mandates/deleteMandateLastSeen", mandate);
        mandatesToUpdate.push(MandateORM.find(mandate.id));
      });
      return mandatesToUpdate;
    },
    // update multiple last seen from AG app
    async updateMultipleMandatesLastSeen(mandatesToUpdate) {
      await MandateORM.api().UPDATE_MULTIPLE_LAST_SEEN(mandatesToUpdate);
    },
    // update meeting minutes after update multiple last seen
    async saveModifiedMeetingMinutesInDb(meetingId) {
      var meeting = MeetingORM.find(meetingId);
      await MeetingMW.PUT(meeting, false);
    },
    showVideoMandatesThatLeft(leftVideoMandates) {
      // Get only the newest mandates that left
      var onlyInLeftVideoMandates = leftVideoMandates.filter(
        this.comparer(this.lastVideoMandatesThatLeft)
      );
      onlyInLeftVideoMandates.forEach(mandate => {
        // TODO Implement for GUEST - L'invité [GUEST NAME] s'est déconnecté à la réunion.
        if (
          mandate.building_owner_id != mandate.representant_owner_id &&
          mandate.representant_owner_id
        ) {
          // Bowner is represented by other bOwner
          const h = this.$createElement;
          const message = h("p", [
            "Le représentant ",
            h("strong", this.getPersonName({ personId: mandate.representant_owner_id })),
            " de propriétaire ",
            h("strong", this.getPersonName({ personId: mandate.building_owner_id })),
            " s'est déconnecté de la réunion.",
          ]);
          this.$bvToast.toast(message, {
            title: "Représentant déconnecté",
            variant: "warning",
            solid: true,
            autoHideDelay: 10000,
          });
        } else if (mandate.building_owner_id == mandate.representant_owner_id) {
          // Bowner is represented by itself
          this.notificationDefaultLeft(mandate);
        } else if (mandate.representant_contact_id) {
          // Bowner is represented by contact
          const h = this.$createElement;
          const message = h("p", [
            "Le représentant ",
            h("strong", this.getPersonName({ personId: mandate.representant_contact_id })),
            " de propriétaire ",
            h("strong", this.getPersonName({ personId: mandate.building_owner_id })),
            " s'est déconnecté de la réunion.",
          ]);
          this.$bvToast.toast(message, {
            title: "Représentant déconnecté",
            variant: "warning",
            solid: true,
            autoHideDelay: 10000,
          });
        } else {
          // Default Bowner
          this.notificationDefaultLeft(mandate);
        }
      });
      this.lastVideoMandatesThatLeft = leftVideoMandates;
    },
    notificationDefaultLeft(mandate) {
      const h = this.$createElement;
      const message = h("p", [
        "Le propriétaire ",
        h("strong", this.getPersonName({ personId: mandate.building_owner_id })),
        " s'est déconnecté de la réunion.",
      ]);
      this.$bvToast.toast(message, {
        title: "Propriétaire déconnecté",
        variant: "warning",
        solid: true,
        autoHideDelay: 10000,
      });
    },
    showVideoMandatesThatArrived(arrivedVideoMandates) {
      // Get only the newest arrived mandates
      var onlyInConcatenatedVideoPresence = arrivedVideoMandates.filter(
        this.comparer(this.lastVideoMandatesThatArrive)
      );
      onlyInConcatenatedVideoPresence.forEach(mandate => {
        // TODO Implement for GUEST - L'invité [GUEST NAME] s'est connecté à la réunion.
        if (
          mandate.building_owner_id != mandate.representant_owner_id &&
          mandate.representant_owner_id
        ) {
          // Bowner is represented by other bOwner
          const h = this.$createElement;
          const message = h("p", [
            "Le représentant ",
            h("strong", this.getPersonName({ personId: mandate.representant_owner_id })),
            " de propriétaire ",
            h("strong", this.getPersonName({ personId: mandate.building_owner_id })),
            " s'est connecté à la réunion.",
          ]);
          this.$bvToast.toast(message, {
            title: "Représentant connectée",
            variant: "success",
            solid: true,
            autoHideDelay: 10000,
          });
        } else if (mandate.building_owner_id == mandate.representant_owner_id) {
          // Bowner is represented by itself
          this.notificationDefaultArrive(mandate);
        } else if (mandate.representant_contact_id) {
          // Bowner is represented by contact
          const h = this.$createElement;
          const message = h("p", [
            "Le représentant ",
            h(
              "strong",
              this.getPersonName({
                personId: mandate.representant_contact_id,
                personType: "contact",
              })
            ),
            " de propriétaire ",
            h("strong", this.getPersonName({ personId: mandate.building_owner_id })),
            " s'est connecté de la réunion.",
          ]);
          this.$bvToast.toast(message, {
            title: "Représentant connectée",
            variant: "success",
            solid: true,
            autoHideDelay: 10000,
          });
        } else {
          // Default Bowner
          this.notificationDefaultArrive(mandate);
        }
      });
      // Save last arrived mandates in order to make a difference between what have arrived and what is arriving
      this.lastVideoMandatesThatArrive = arrivedVideoMandates;
    },
    notificationDefaultArrive(mandate) {
      const h = this.$createElement;
      const message = h("p", [
        "Le propriétaire ",
        h("strong", this.getPersonName({ personId: mandate.building_owner_id })),
        " s'est connecté à la réunion.",
      ]);
      this.$bvToast.toast(message, {
        title: "Propriétaire connectée",
        variant: "success",
        solid: true,
        autoHideDelay: 10000,
      });
    },
    filterMajorities(majorities, buildingId) {
      const buildingMajorities = BuildingMajoritiesORM.query()
        .where("agency_id", this.meeting.agency_id)
        .where("building_id", buildingId)
        .get();

      let filtered = [];

      buildingMajorities.forEach(buildingMajority => {
        let majority = this.$_.find(majorities, item => item.id == buildingMajority.majority_id);
        if (majority) filtered.push(majority);
      });

      return filtered;
    },
  },
};
